import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useLoansStore} from "../../store/loans.store";

export const useLoanVendors = () => {
    const setLoanVendors = useLoansStore((state) => state.setLoanVendors);

    return useMutation(PartnerApi.loanVendors, {
        onSuccess: (data) => {
            setLoanVendors(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};